









import { Component, Vue } from 'vue-property-decorator';

import LoginCard from '@/components/LoginCard.vue';

@Component({
  components: {
    LoginCard,
  },
})
export default class LoginPage extends Vue {}
